<template lang='pug'>
  div
    a.browse-products-btn.external-link(:href='browseProductsUrl' v-if='isBrowseProductsLinkToExternal' v-t='"browseProducts"' @click.prevent='recordClickOnBrowseProductsAndRedirect()')
    router-link.browse-products-btn(:to='browseProductsPath' v-if='!isBrowseProductsLinkToExternal' v-t='"browseProducts"' @click.native='recordClickOnBrowseProducts()' aria-label='Close' data-dismiss='modal')
</template>

<i18n>
{
  "lng_en": {
    "browseProducts": "BROWSE PRODUCTS"
  },
  "lng_zh": {
    "browseProducts": "浏览产品"
  },
  "lng_th": {
    "browseProducts": "เรียกดูผลิตภัณฑ์"
  },
  "lng_id": {
    "browseProducts": "TELUSURI PRODUK"
  },
  "lng_ko": {
    "browseProducts": "제품 찾아보기"
  }
}
</i18n>

<script>
import { promoCodeMixin } from '@/mixins/promo-code-mixin'
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  name: 'BrowseProductsButton',
  mixins: [
    promoCodeMixin
  ],
  props: {
    promoCodeAttrs: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    recordClickOnBrowseProducts () {
      pushDataLayerEvent(
        'doeals_for_you_card_details_browse_products', {
          params: {
            deal_sequence: this.promoCodeAttrs['card-sequence-number'],
            coupon_code: this.promoCodeAttrs.code
          }
        }
      )
    },
    recordClickOnBrowseProductsAndRedirect () {
      this.recordClickOnBrowseProducts()
      window.location.href = this.browseProductsUrl
    }
  }
}
</script>

<style lang="scss" scoped>
  .browse-products-btn {
    padding: 10px 0px;
    font-weight: bold;
    background-color: $black;
    color: $white;
    display: block;
    width: 100%;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: $white;
    }
  }
</style>
